// Frontend mirror of the backend SUBJECTS_DATA. Used as a fallback if /api/subjects fails.
export const SUBJECTS_FALLBACK = {
  "Career Skills": {
    Digital: [
      "Coding & Programming",
      "Web Development",
      "App Development",
      "Data Science",
      "AI & Machine Learning",
      "UI/UX Design",
      "Digital Marketing",
      "Cybersecurity",
    ],
    Creative: ["Graphic Design", "Video Editing", "Animation", "Photography", "Content Writing", "Music Production"],
    Business: ["Entrepreneurship", "Public Speaking", "Leadership", "Marketing Basics", "E-commerce"],
    Trades: ["Electronics", "Carpentry Basics", "DIY Projects", "Robotics"],
    Finance: ["Personal Finance", "Stock Market Basics", "Cryptocurrency Basics", "Budgeting"],
  },
  Activities: {
    Communication: ["Debate", "Storytelling", "Drama & Theatre", "Elocution"],
    Arts: ["Drawing", "Painting", "Sculpting", "Calligraphy", "Origami"],
    Cognitive: ["Chess", "Rubik's Cube", "Memory Techniques", "Vedic Maths", "Abacus"],
    "Life Skills": ["Cooking", "Time Management", "Etiquette", "First Aid", "Mindfulness"],
  },
  Sports: {
    Team: ["Football", "Cricket", "Basketball", "Volleyball", "Hockey"],
    Individual: ["Tennis", "Badminton", "Table Tennis", "Swimming", "Athletics"],
    Fitness: ["Yoga", "Aerobics", "Calisthenics", "Strength Training"],
    Niche: ["Skating", "Archery", "Martial Arts", "Gymnastics", "Climbing"],
  },
  "Development & Wellness": {
    "Child Development": ["Early Learning", "Phonics", "Motor Skills", "Social Skills"],
    Mental: ["Mindfulness for Kids", "Counselling", "Anxiety Coaching", "Confidence Building"],
    "Special Needs": ["Speech Therapy", "Occupational Therapy", "Autism Support", "Dyslexia Support"],
  },
  Hobbies: {
    Skills: ["Magic Tricks", "Puppetry", "Knitting", "Pottery"],
    Lifestyle: ["Gardening", "Pet Care", "Sustainable Living"],
    Exploration: ["Astronomy", "Birdwatching", "Geography Quiz", "Travel Journaling"],
  },
  Academics: {
    "All Subjects": ["Pre-School", "Primary School", "Middle School", "High School", "Senior Secondary"],
    Languages: ["English", "Hindi", "Spanish", "French", "German", "Mandarin", "Sanskrit"],
    Math: ["Arithmetic", "Algebra", "Geometry", "Trigonometry", "Calculus", "Statistics"],
    Science: ["Physics", "Chemistry", "Biology", "Environmental Science", "Computer Science"],
  },
};
